import { parsePgArray } from 'utils/format';
import { title2Field } from '../AssetManagerContext';
export function filterAssetEntry(row, text) {
    function contains(longText) {
        return longText && longText.toLowerCase().includes(text);
    }

    function arrayContains(array) {
        for (const entry of array) {
            if (contains(entry)) {
                return true;
            }
        }
        return false;
    }

    function enumArrayContains(enumArray) {
        return arrayContains(parsePgArray(enumArray));
    }

    if (contains(row.address)) {
        return true;
    }

    if (contains(row.city)) {
        return true;
    }

    if (contains(row.county)) {
        return true;
    }

    if (contains(row.state)) {
        return true;
    }

    if (contains(row.zip)) {
        return true;
    }

    if (contains(row.titleholder)) {
        return true;
    }

    if (enumArrayContains(row.project_strategy)) {
        return true;
    }

    if (enumArrayContains(row.business_line)) {
        return true;
    }

    if (enumArrayContains(row.property_type)) {
        return true;
    }

    if (enumArrayContains(row.occupancy_status)) {
        return true;
    }

    if (contains(row.transaction_status)) {
        return true;
    }

    if (contains(row.title_binder_info)) {
        return true;
    }

    if (contains(row.relisting_agent)) {
        return true;
    }

    if (enumArrayContains(row.rental_status)) {
        return true;
    }
    return false;
}

export function comprehensiveAssetFilter(row, assetFilters, filterLogic) {
    // console.log('comprehensiveAssetFilter', assetFilters);
    if (!assetFilters || assetFilters.length === 0) return true;
    // console.log('comprehensiveAssetFilter');
    const evaluateFilter = (filter) => {
        const { field, operator, value, type } = filter;
        const cellValue = row[title2Field[field]];
        // console.log(row);
        // if (field === 'Transaction Status') {
        //     console.log('Transaction Status', cellValue);
        // }

        // if (field === 'Rental Status') {
        //     console.log('Rental Status', cellValue);
        // }

        const isEmpty = (val) =>
            val === null ||
            val === undefined ||
            val === '' ||
            val === '{}' ||
            (Array.isArray(val) && val.length === 0);

        // Handle missing data gracefully
        if (isEmpty(cellValue)) return false;

        // number: ['=', '>', '<', '>=', '<=', 'between']
        switch (type) {
            case 'number': {
                const num = Number(cellValue);
                if (isNaN(num)) return false;
                switch (operator) {
                    case '=':
                        return num === Number(value);
                    case '>':
                        return num > Number(value);
                    case '<':
                        return num < Number(value);
                    case '>=':
                        return num >= Number(value);
                    case '<=':
                        return num <= Number(value);
                    case 'between':
                        if (!Array.isArray(value)) return false;
                        const [min, max] = value.map(Number);
                        return num >= min && num <= max;
                    default:
                        return false;
                }
            }

            // string: ['equals', 'contains', 'starts with', 'ends with']
            case 'string': {
                const str = String(cellValue).toLowerCase();
                const val = String(value || '').toLowerCase();
                switch (operator) {
                    case 'equals':
                        return str === val;
                    case 'contains':
                        return str.includes(val);
                    case 'starts with':
                        return str.startsWith(val);
                    case 'ends with':
                        return str.endsWith(val);
                    default:
                        return false;
                }
            }

            // enum: ['contains']
            case 'enum': {
                const str = String(cellValue).toLowerCase();
                const val = String(value || '').toLowerCase();
                return str === val || str.includes(val);
            }

            // 'multi enum': ['contains']
            case 'multi enum': {
                const vals = Array.isArray(value)
                    ? value.map((v) => v.toLowerCase())
                    : [];

                // Normalize cell value — handle array or string
                const cellVals = parsePgArray(cellValue).map((v) =>
                    v.toLowerCase()
                );
                // ✅ Require that ALL selected filter values appear in the cell
                return vals.every((v) => cellVals.includes(v));
            }

            // boolean: ['is'], // boolean operators
            case 'boolean': {
                const boolVal = cellValue === true || cellValue === 'true';
                const target = value === true || value === 'true';
                console.log('boolVal', boolVal, 'target', target);
                return operator === 'is' ? boolVal === target : false;
            }

            // date: ['=', 'before', 'after', 'between'], // date operators
            case 'date': {
                const cellDate = new Date(cellValue);
                if (isNaN(cellDate)) return false;
                if (operator === 'between' && Array.isArray(value)) {
                    const [start, end] = value.map((v) => new Date(v));
                    return cellDate >= start && cellDate <= end;
                }
                const valDate = new Date(value);
                switch (operator) {
                    case '=':
                        return (
                            cellDate.toDateString() === valDate.toDateString()
                        );
                    case 'before':
                        return cellDate < valDate;
                    case 'after':
                        return cellDate > valDate;
                    default:
                        return false;
                }
            }

            default:
                return true;
        }
    };

    console.log('evaluateFilter', evaluateFilter);

    // Evaluate all filters based on selected logic
    if (filterLogic === 'all') {
        return assetFilters.every(evaluateFilter);
    } else {
        return assetFilters.some(evaluateFilter);
    }
}
